document.addEventListener('DOMContentLoaded', function () {
    // Listen for "Quick Add" button clicks
    document.querySelectorAll('.quick-add-button').forEach(button => {
        button.addEventListener('click', function (event) {
            event.preventDefault();

            // Get the product variant ID and quantity input
            const form = button.closest('form');
            const variantId = form.querySelector('[name="id"]').value;
            const quantityInput = form.querySelector('[name="quantity"]');
            let quantity = parseInt(quantityInput.value);

            // Fetch the MOQ for the selected variant (from a data attribute)
            const moq = parseInt(quantityInput.dataset.min || 1);

            // Validate the quantity against the MOQ
            if (quantity < moq) {
                alert(`The minimum order quantity for this item is ${moq}.`);
                quantityInput.value = moq; // Set the input value to MOQ
                return;
            }

            // Proceed with adding the item to the cart
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    id: variantId,
                    quantity: quantity,
                }),
            })
                .then(response => {
                    if (!response.ok) throw new Error('Failed to add item to cart.');
                    return response.json();
                })
                .then(data => {
                    console.log('Item added to cart:', data);
                    window.location.href = '/cart'; // Redirect to cart page (optional)
                })
                .catch(error => {
                    console.error('Error adding item to cart:', error);
                    alert('There was an error adding the item to your cart.');
                });
        });
    });
});